import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useRemoveUser } from "@/hooks/remove-user.hook";
import { GetUsersByCompanyIdResponseContent } from "@/requests/users/users-by-company.request";
import { FC } from "react";

type RemoveUserDialogProps = {
  user: GetUsersByCompanyIdResponseContent | null;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

const RemoveUserDialog: FC<RemoveUserDialogProps> = ({ user, ...props }) => {
  const mutation = useRemoveUser();

  const handleOK = () => {
    if (user?.companyId && user?.id) {
      mutation.mutate({
        companyId: user.companyId,
        userId: user.id,
        email: user.email,
      });
    }
  };

  return user ? (
    <AlertDialog open={props.isOpen} onOpenChange={props.onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Quieres eliminar {user.email}?</AlertDialogTitle>
          <AlertDialogDescription>
            Vas a eliminar el acceso al usuario {user.name}.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={handleOK}>Continuar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  ) : null;
};

export default RemoveUserDialog;
